import { LOCALE_URL_PREFIXES } from '@/modules/languages/lib/catalog'

export type LocalePrefixHit = {
  /** Código do idioma como aparece no catálogo (minúsculo). */
  locale: string
  /** Caminho sem o prefixo (sempre começa por `/`). */
  rest: string
}

/**
 * Detecta prefixo de idioma no início do caminho (`/en`, `/en/...`, `/zh-cn/...`).
 * Reconhece TODOS os códigos do catálogo — URLs da era GTranslate (site WP) usam qualquer um.
 * Não decide o que fazer (301 vs servir) — isso é do chamador (proxy) conforme a fase do módulo.
 */
export function stripLocalePrefix(pathname: string): LocalePrefixHit | null {
  if (!pathname.startsWith('/')) return null
  const firstSegEnd = pathname.indexOf('/', 1)
  const seg = (firstSegEnd === -1 ? pathname.slice(1) : pathname.slice(1, firstSegEnd)).toLowerCase()
  if (!seg || !LOCALE_URL_PREFIXES.has(seg)) return null
  const rest = firstSegEnd === -1 ? '/' : pathname.slice(firstSegEnd) || '/'
  return { locale: seg, rest }
}
